module.exports = __webpack_public_path__ + "static/img/muzychuk.25bd5c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/muzychuk.jpg
// module id = 488
// module chunks = 11